import * as React from "react"
import type { SVGProps } from "react"
const SvgRecommendationPaid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9.95 4.26a7.8 7.8 0 0 1 6.1.84q.52.3 1 .67.47.38.87.84.3.32.25.74a1 1 0 0 1-.42.66q-.36.22-.76.17a1.2 1.2 0 0 1-.7-.38q-.27-.3-.58-.53a6.1 6.1 0 0 0-5.25-1.07A5.8 5.8 0 0 0 6.81 9l-.08.15 1.23-.33q.38-.1.74.11t.47.6q.1.36-.11.74a1 1 0 0 1-.6.46l-3.54.96a.96.96 0 0 1-1.22-.7l-.95-3.56a1 1 0 0 1 .11-.74q.22-.37.6-.47.36-.1.74.11.37.22.46.6L5 8.14 5.1 8a7.7 7.7 0 0 1 4.86-3.74" />
    <path
      fillRule="evenodd"
      d="M12.34 20a6 6 0 0 1-.34-1.99 6 6 0 0 1-4.28-1.8q-.3-.33-.71-.4a1 1 0 0 0-.77.17 1 1 0 0 0-.41.64q-.06.42.23.72a7.9 7.9 0 0 0 6.28 2.67m6.65-4.14.03.02-.02-.04z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="m19.02 15.89-.02-.04-.01.02z"
      clipRule="evenodd"
    />
    <path d="M15.83 17.56q.39.42 1.14.74.3.14.67.27.83.26 1.18.54t.34.63q0 .32-.3.58-.3.24-.84.25-.28 0-.6-.18a2 2 0 0 1-.59-.52q-.21-.3-.51-.42a1 1 0 0 0-.61 0 .8.8 0 0 0-.49.43q-.15.32 0 .63.27.56.8.98.54.43 1.23.6v.2q0 .31.21.51t.49.2q.26 0 .45-.2a.7.7 0 0 0 .2-.5v-.16a3 3 0 0 0 1.61-.84q.64-.68.64-1.56 0-.98-.54-1.56-.52-.6-1.65-.98l-.45-.15a4 4 0 0 1-.94-.47q-.3-.27-.31-.55 0-.26.25-.45.25-.18.69-.18.21 0 .44.07.22.07.36.2l.29.2.01-.02.02.04q.17.1.34.15.3.08.55-.01.33-.14.45-.47a.7.7 0 0 0-.08-.62q-.3-.42-.74-.68-.43-.26-.95-.37v-.19q0-.3-.18-.5a.6.6 0 0 0-.48-.2.7.7 0 0 0-.68.7v.19a2.4 2.4 0 0 0-1.74 1.27q-.24.45-.23.94 0 .47.15.84.13.35.4.62" />
  </svg>
)
export default SvgRecommendationPaid
